import axios from 'axios';
import { notify } from './notify';

const API_URL = import.meta.env.VITE_API_URL || '/api';

const axiosInstance = axios.create({
  baseURL: API_URL,
  // ТСД в Wi-Fi-мёртвой зоне иначе висит на запросе бесконечно.
  timeout: 20000,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: false,
});

// Request interceptor - добавляем токен
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - обрабатываем ошибки
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // 401 - не авторизован
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
      return Promise.reject(error);
    }
    
    // Показываем уведомление об ошибке, если запрос не помечен как тихий
    if (!error.config?.silent) {
      const msg = error?.response?.data?.message || error.message || 'Ошибка';
      notify(msg, { variant: 'error' });
    }
    
    return Promise.reject(error);
  }
);

export default axiosInstance;
